import genericStore from "../generic_store";
import axios from "axios";
import { config } from "@/config/constants.js";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "user_push_notifications",
    object: "user_push_notification",
    header: [
      // { text: "ID", value: "id" },
      { text: "Title", value: "title" },
      { text: "Body", value: "body" },
      { text: "Type", value: "type" },
      { text: "Date", value: "created_at" },
      { text: "Hide", value: "hide" },
     
    ],
  },
  mutations: {
    ...genericStore.mutations,
  },
  actions: {
    ...genericStore.actions,
    hide_notification({ commit, state }, options) {
      return new Promise((resolve, reject) => {
        commit("request");
        let filter = {
          ...options,
          search: ""
        };
        console.log('hide_notification');
        console.log(options);
        axios
          .post(config.api_url + "hide_notification", { params:  options})
          .then(response => {
            commit("success");
            resolve(response.data);
          })
          .catch(err => {
            commit("error");
            reject(err);
          });
      });
    }
  },
  getters: {
    ...genericStore.getters,
  },
};
